import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";

const units: any = [
  {
    unit: "ITEM",
    usePrefix: "Purchased",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "ITEMS",
    usePrefix: "Purchased",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "AMOUNT",
    usePrefix: "Purchased",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "DOLLARS",
    usePrefix: "Purchased",
    valuePrefix: "$",
    valuePostFix: "",
  },
  {
    unit: "QUANTITY_PRICE",
    usePrefix: "Purchased",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "POUND",
    usePrefix: "Purchased",
    valuePostFix: "Lbs",
    valuePrefix: "",
  },
  {
    unit: "PER POUND",
    usePrefix: "Purchased",
    valuePostFix: "Lbs",
    valuePrefix: "",
  },
  {
    unit: "WEIGHT_VOLUME",
    usePrefix: "Quantity",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "WEIGHT/VOLUME",
    usePrefix: "Quantity",
    valuePrefix: "",
    valuePostFix: "",
  },
  {
    unit: "QUANTITY",
    usePrefix: "Quantity",
    valuePrefix: "",
    valuePostFix: "",
  },
];

@Component({
  selector: "loyalty-card-action-buttons",
  templateUrl: "./loyalty-card-action-buttons.component.html",
  styleUrls: ["./loyalty-card-action-buttons.component.scss"],
})
export class LoyaltyCardActionButtonsComponent implements OnInit {
  @Input() cardType: string = "";
  @Input() data: any;
  public continuityOfferType: string = "continuity";
  public freshPassContinuityOffer: string = "IA FRESHPASS";
  public behavioralOfferAttrs = {
    startChallengeButtonName: "Activate",
    challengeCompletedStatusText: "Bonus Path Completed",
    inProgressStatusText: "In Progress",
    grClipTextOMS: "GR Clip",
    ucaEmailOptInTextOMS: "UCA Email Opt In",
    ecomFulfillmentTextOMS: "ECOM Fulfillment",
    grClipButtonText: "Go to Grocery Rewards",
    ucaEmailOptInButtonText: "Go to Account Settings",
    ecomFulfillmentButtonText: "Go to My Cart",
    ucaEmailOptInLink: "/customer-account/communication-preference.html",
    ecomFulfillmentLink: "/",
    grClipLink: "/foru/rewards.html",
    addToMyListBtnText: "Add to List",
    viewInMyListText: "View in My List",
    myListLink: "/mylist.html",
    startShoppingText: "Start Shopping",
    startShoppingLink: "/",
    freshPassOfferText: "Redeem FreshPass offer",
    freshPassOfferLink: "/freshpass/manage/subscribe",
  };
  isBehaviorCoupon: boolean = false;
  isContinuityCoupon: boolean = false;
  isCouponClipped: boolean = false;
  isBonusPathCompleted: boolean = false;
  public startChallengeLabel: string;
  public challengeCompletedLabel: string;
  showLoadingCoupon: boolean = false;
  public showBoxtop: boolean = false;
  public clipCouponBtnLabel: string = "";
  public addToMyListBtnLabel: string = "";
  challengeCompletedLabelColor: string = '#757575';
  fontSize: string = '12px';
  @Output() emitClippedCoupon = new EventEmitter();

  constructor() {
    this.startChallengeLabel =
      window["SWY"].CONFIGSERVICE.nimbusConfig.couponActionTypes["SCC"];
    this.challengeCompletedLabel =
      window["SWY"].CONFIGSERVICE.nimbusConfig.couponActionTypes["CC"];
  }

  ngOnInit(): void {
    if (window?.["SWY"]?.CONFIGSERVICE?.featureToggleConfig?.enableB4UPlusLaunch === true) {
      this.behavioralOfferAttrs.freshPassOfferText = "Claim forU+ plan";
      this.behavioralOfferAttrs.freshPassOfferLink = "/foruplus";
    }
    this.data.offerPrice = this.data.offerPrice ? this.data.offerPrice : '';
    this.clipCouponBtnLabel = this.data?.deleted ? this.behavioralOfferAttrs && this.behavioralOfferAttrs?.addToMyListBtnText ? this.behavioralOfferAttrs?.addToMyListBtnText : `${this.data.offerPrice} Add to List` : `${this.data.offerPrice} Clip Coupon`;
    this.addToMyListBtnLabel = this.data?.deleted  ? this.behavioralOfferAttrs && this.behavioralOfferAttrs?.addToMyListBtnText ? this.behavioralOfferAttrs?.addToMyListBtnText : `${this.data.offerPrice} Add to List` : `${this.data.offerPrice} ${this.startChallengeLabel}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.cardType === 'coupon') {
      this.checkOfferStatus();
    }
  }

  public isBehaviourOrContinuityCoupon(coupon): boolean {
    return coupon?.continuity
      || coupon?.offerProtoType?.toLowerCase() === this.continuityOfferType
      || coupon?.offerProgramType?.toLowerCase() === this.continuityOfferType
      || (coupon.qualificationBehavior && coupon.qualificationBehavior !== "");
  }

  public isFreshpassContinuityCoupon(coupon): boolean {
    let flag = false;
    if (
      coupon.continuity &&
      coupon.programSubType &&
      coupon.programSubType.trim().toLowerCase() ===
        this.freshPassContinuityOffer.trim().toLocaleLowerCase()
    ) {
      flag = true;
    }
    return flag;
  }

  checkOfferStatus() {
    if (this.data.status && this.data.status === "C" && this.data.deleted) {
      this.isCouponClipped = false;
    } else if (
      (this.data.status && this.data.status === "C" && !this.data.deleted) ||
      (!this.data.status && !this.data.deleted && !this.isBehaviourOrContinuityCoupon(this.data))
    ) {
      this.isCouponClipped = true;
      if (this.data.continuity ) {
          this.isBonusPathCompleted =
            this.data.continuity.progressValue ===
            this.data.continuity.targetValue;
          this.isContinuityCoupon = true;
          this.isBehaviorCoupon = false;
        } else if (
          this.data.offerProtoType?.toLowerCase() === this.continuityOfferType ||
          this.data.offerProgramType?.toLowerCase() === this.continuityOfferType
        ) {
          this.isBonusPathCompleted = true;
          this.isContinuityCoupon = false;
          this.isBehaviorCoupon = false;
        } else if (
          this.data.qualificationBehavior &&
          this.data.qualificationBehavior !== ""
        ) {
          this.isBonusPathCompleted =
            this.data.bonusPathStatus !== "" &&
            this.data.bonusPathStatus.toLowerCase() !== "inprogress";
          this.isContinuityCoupon = false;
          this.isBehaviorCoupon = true;
        }
    } else if ((this.data.status === "U" && !this.data.deleted) || (this.data.status === "U" && this.data.deleted)) {
      this.isCouponClipped = false;
    }
  }

  navigateTo(offerChallegeLink) {
    this.showLoadingCoupon = true;
    window.location.pathname = offerChallegeLink;
  }

  offerDataDisplay(data) {
    let vals: any = {};
    if (data?.units) {
      const findIndexFromUnits = units.findIndex(
        (u) => u.unit.toLowerCase() === data.units.toLowerCase()
      );
  
      if (findIndexFromUnits >= 0) {
        const _unit = units[findIndexFromUnits];
        vals = {
          prefix: _unit.usePrefix,
          progressVal: _unit.valuePrefix
            ? `${_unit.valuePrefix}${data.progressValue}`
            : _unit.valuePostFix
            ? `${data.progressValue}${_unit.valuePostFix}`
            : data.progressValue,
          targetVal: _unit.valuePrefix
            ? `${_unit.valuePrefix}${data.targetValue}`
            : _unit.valuePostFix
            ? `${data.targetValue}${_unit.valuePostFix}`
            : data.targetValue,
        };
      }
    } else {
      vals = {
        prefix: 'Transactions',
        progressVal: data.progressValue,
        targetVal: data.targetValue
      }
    }
    

    return vals;
  }

  clipCoupon(coupon, $event?: Event) {
    if (event && event.isTrusted) {
      coupon.$event = $event;
      this.emitClippedCoupon.emit(coupon);
    }
  }

  getStyle(data) {
    const width = (data?.continuity.progressValue * 100) / data?.continuity.targetValue;
    const height = 'inherit';
    return `width: ${width}%; height: ${height}`;
  }

}
